import React, { Component, Fragment } from 'react'
import { Breadcrumb, Card, Row, Tabs } from 'antd'
import { get } from 'lodash'
import IconText from '../../../../elements/IconText'
import { withRouter } from 'react-router-dom'
import VehiclesList from '../../../../components/Operations/Transport/InService/VehiclesList'
import FilterForm from '../../../../components/Operations/Transport/InService/FilterForm'
import VehicleModal from '../../../../components/Operations/Transport/InService/VehicleModal'

const { TabPane } = Tabs

class InService extends Component {
  render() {
    const { formRef } = this.props
    return (
      <Fragment>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Operations</Breadcrumb.Item>
              <Breadcrumb.Item>Transport</Breadcrumb.Item>
              <Breadcrumb.Item>In-Service</Breadcrumb.Item>
            </Breadcrumb>
            <h2>In Service Resources</h2>
            <p>View and list In Service Resources.</p>
            <FilterForm {...this.props} ref={formRef} />
          </Row>
        </Card>
        <Card>
          <Tabs
            defaultActiveKey={get(this.props, 'location.hash') || '#bookings'}
            onChange={(key) => this.props.history.push(key)}>
            <TabPane tab={<IconText text={'Vehicles'} type={'car'} />} key="#vehicles">
              <VehicleModal {...this.props} />
              <VehiclesList {...this.props} />
            </TabPane>
          </Tabs>
        </Card>
      </Fragment>
    )
  }
}


export default withRouter(InService)
